<!-- Global Loader Overlay -->
<div *ngIf="showGlobalLoader" class="global-loader-overlay">
	<div class="global-loader-spinner"></div>
	<span class="global-loader-text">Chargement...</span>
</div>
<style>
.global-loader-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(255,255,255,0.7);
	z-index: 9999;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.global-loader-spinner {
	border: 6px solid #f3f3f3;
	border-top: 6px solid #3498db;
	border-radius: 50%;
	width: 48px;
	height: 48px;
	animation: spin 1s linear infinite;
	margin-bottom: 16px;
}
.global-loader-text {
	font-size: 1.2rem;
	color: #333;
	font-weight: 500;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>
<div class="min-h-screen bg-gray-50">
	<div class="w-full px-4 py-8">
		<div class="max-w-5xl mx-auto">
			<!-- Header -->
			<div class="mb-8">
				<h1 class="text-3xl font-bold text-gray-900 mb-2">{{ btnTitle === 'Modifier' ? 'Modifier le produit' : 'Ajouter un produit' }}</h1>
				<p class="text-gray-600">{{ btnTitle === 'Modifier' ? 'Mettez à jour les détails du produit' : 'Créez un nouveau produit avec image et détails' }}</p>
			</div>

			<!-- Main Form Card -->
			<div class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
				<!-- Image Upload Section -->
				<div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100 p-8">
					<div class="text-center">
						<h2 class="text-lg font-semibold text-gray-900 mb-2">Image du produit</h2>
						<p class="text-sm text-gray-600 mb-6">Cliquez sur l'avatar pour télécharger une photo</p>
						
						<!-- Centered Avatar -->
						<div class="flex justify-center mb-6">
							<div class="thumbnail-picker-xl relative group" (click)="!imagePreview && !(newProduct.imageUrl && btnTitle === 'Modifier') ? fileInput.click() : null" role="button" tabindex="0" (keydown.enter)="fileInput.click()">
								<!-- Loader while image is loading (from backend or file explorer) -->
								<div *ngIf="imageLoading" class="image-loader-overlay">
									<div class="image-loader-spinner"></div>
								</div>
								<!-- Show image preview if available -->
								<img *ngIf="imagePreview" [src]="imagePreview" alt="Aperçu image produit" class="thumb-img-xl" (click)="toggleImageActions($event)" />
								<!-- Show existing product image in edit mode -->
								 <img *ngIf="!imagePreview && imageBlobUrl && btnTitle === 'Modifier' && !imageLoading"
									 [src]="imageBlobUrl"
									 alt="Image du produit" class="thumb-img-xl" (click)="toggleImageActions($event)" />
								<!-- Show camera icon as fallback -->
								<div *ngIf="!imagePreview && !(newProduct.imageUrl && btnTitle === 'Modifier') && !imageLoading" class="avatar-circle-xl">
									<i class="fa fa-camera text-5xl"></i>
								</div>
								<!-- Hover overlay (only when no image yet) -->
								<div class="thumb-overlay-xl" *ngIf="!imagePreview && !(newProduct.imageUrl && btnTitle === 'Modifier') && !imageLoading">
									<div class="overlay-text-xl">
										<i class="fa fa-camera mr-2"></i>
										Ajouter une photo
									</div>
								</div>

								<!-- Click action overlay when image exists -->
								<div *ngIf="imagePreview || (newProduct.imageUrl && btnTitle === 'Modifier')" class="actions-overlay"
									 [class.opacity-100]="showImageActions">
									<button type="button" class="relative overlay-action-btn text-blue-600 w-12 h-12 flex items-center justify-center" (click)="viewFullImage($event)" title="Voir en grand" aria-label="Voir en grand">
										<style>
											.image-loader-overlay {
												position: absolute;
												top: 0;
												left: 0;
												width: 100%;
												height: 100%;
												background: rgba(255,255,255,0.7);
												display: flex;
												align-items: center;
												justify-content: center;
												z-index: 2;
											}
											.image-loader-spinner {
												border: 4px solid #f3f3f3;
												border-top: 4px solid #3498db;
												border-radius: 50%;
												width: 32px;
												height: 32px;
												animation: spin 1s linear infinite;
											}
										</style>
										<!-- Feather zoom-in (outline) -->
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
											<circle cx="11" cy="11" r="8"></circle>
											<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
											<line x1="11" y1="8" x2="11" y2="14"></line>
											<line x1="8" y1="11" x2="14" y2="11"></line>
										</svg>
									</button>
									<button type="button" class="relative overlay-action-btn text-green-600 w-12 h-12 flex items-center justify-center" (click)="$event.stopPropagation(); fileInput.click()" title="Changer l'image" aria-label="Changer l'image">
										<!-- Feather camera (outline) -->
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
											<path d="M23 19a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3l2-2h6l2 2h3a3 3 0 0 1 3 3z"></path>
											<circle cx="12" cy="13" r="4"></circle>
										</svg>
									</button>
								</div>
							</div>
							<input #fileInput type="file" accept="image/*" (change)="onImageSelected($event)" hidden />
						</div>

						<!-- Image Actions -->
						<div class="flex justify-center gap-3 flex-wrap mb-4">
							<button class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200" type="button" [disabled]="!selectedFile || uploadInProgress" (click)="uploadImage()">
								{{ uploadInProgress ? 'Téléchargement…' : 'Télécharger' }}
							</button>
							<button class="px-4 py-2 border border-red-300 hover:bg-red-50 text-red-600 text-sm font-medium rounded-lg transition-colors duration-200" type="button" (click)="clearImage()">Effacer</button>
						</div>

						<!-- Status Messages -->
						<div class="text-center">
							<span class="block text-sm font-medium" *ngIf="uploadSuccess" style="color:#10b981;">✓ Image téléchargée avec succès</span>
							<span class="block text-sm font-medium" *ngIf="uploadError" style="color:#ef4444;">{{ uploadError }}</span>
						</div>
					</div>
				</div>

				<!-- Form Content -->
				<div class="p-8">
					<!-- Basic Information Section -->
					<div class="mb-8">
						<h3 class="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-3">
							<i class="fa fa-info-circle text-xl text-blue-600"></i>
							Informations de base
						</h3>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Code barre</label>
								<input type="text" class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.codeBare" name="codeBare" placeholder="Ex: 1234567890123" />
							</div>
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Nom du produit</label>
								<input type="text" class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.name" name="name" placeholder="Ex: Peinture blanche 1L" />
							</div>
						</div>

<!-- Click outside to hide image actions -->
<div *ngIf="showImageActions" class="fixed inset-0 z-40" (click)="showImageActions=false"></div>
					</div>

					<!-- Pricing Section -->
					<div class="mb-8">
						<h3 class="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-3">
							<i class="fa fa-money-bill-wave text-xl text-green-600"></i>
							Tarification
						</h3>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Prix d'achat</label>
								<div class="relative flex items-center">
									   <input type="number" step="0.01" class="w-full h-10 px-4 pr-12 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.purchasePrice" name="purchasePrice" placeholder="5.50" />
									   <span class="absolute right-4 text-sm font-medium text-gray-500">DH</span>
								</div>
							</div>
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Prix de vente</label>
								<div class="relative flex items-center">
									   <input type="number" step="0.01" class="w-full h-10 px-4 pr-12 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.price" name="price" placeholder="8.00" />
									   <span class="absolute right-4 text-sm font-medium text-gray-500">DH</span>
								</div>
							</div>
						</div>
					</div>

					<!-- Inventory Section -->
					<div class="mb-8">
						<h3 class="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-3">
							<i class="fa fa-warehouse text-xl text-purple-600"></i>
							Stock et unités
						</h3>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Quantité</label>
								<input type="number" class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.quantity" name="quantity" placeholder="24" />
							</div>
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Unité de mesure</label>
								<select class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.unit" name="unit">
									<option value="" disabled selected>Sélectionnez une unité</option>
									<option *ngFor="let unit of units" [value]="unit">{{ unit }}</option>
								</select>
							</div>
						</div>
					</div>

					<!-- Classification Section -->
					<div class="mb-8">
						<h3 class="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-3">
							<i class="fa fa-sitemap text-xl text-orange-600"></i>
							Classification
						</h3>
						<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Catégorie</label>
								<select class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.category" name="category" (change)="onCategoryChange(newProduct.category)">
									<option value="" disabled selected>Sélectionnez une catégorie</option>
									<option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
								</select>
							</div>
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Sous-catégorie</label>
								<select class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.subCategory" name="subCategory" [disabled]="!newProduct.category" (change)="onSubCategoryChange(newProduct.subCategory)">
									<option value="" disabled selected>Sélectionnez une sous-catégorie</option>
									<option *ngFor="let sub of subCategories" [value]="sub">{{ sub }}</option>
								</select>
							</div>
							<div>
								<label class="block text-sm font-semibold text-gray-700 mb-2">Famille de produits</label>
								<select class="w-full h-10 px-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200" [(ngModel)]="newProduct.productFamily" name="productFamily" [disabled]="!newProduct.subCategory">
									<option [value]="undefined">-- Aucune (optionnel) --</option>
									<option *ngFor="let family of productFamilies" [value]="family">{{ family }}</option>
								</select>
							</div>
						</div>
					</div>

					<!-- Description Section -->
					<div class="mb-8">
						<h3 class="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-3">
							<i class="fa fa-align-left text-xl text-indigo-600"></i>
							Description
						</h3>
						<textarea rows="4" class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200 resize-none" [(ngModel)]="newProduct.description" name="description" placeholder="Ajoutez des notes, détails ou informations supplémentaires..."></textarea>
					</div>

					<!-- Form Actions -->
					<div class="flex justify-end gap-3 pt-6 border-t border-gray-100">
						<button type="button" class="px-6 py-2.5 border border-gray-300 hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg transition-colors duration-200" (click)="cancel()">Annuler</button>
						<button type="button" class="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 flex items-center justify-center min-w-[120px]" (click)="addOrUpdateProduct()" [disabled]="isAddingProduct">
							<span *ngIf="isAddingProduct" class="loader mr-2"></span>
							<span *ngIf="!isAddingProduct">{{ btnTitle || 'Enregistrer' }}</span>
							<span *ngIf="isAddingProduct">Ajout...</span>
						</button>
					<!-- Loader Spinner CSS -->
					<style>
					.loader {
						border: 3px solid #f3f3f3;
						border-top: 3px solid #3498db;
						border-radius: 50%;
						width: 18px;
						height: 18px;
						animation: spin 1s linear infinite;
						display: inline-block;
					}
					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
					</style>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Image Preview Modal -->
<div *ngIf="showImageModal" class="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-75" (click)="closeImageModal()">
	<div class="relative max-w-7xl max-h-screen p-4">
		<button class="absolute top-2 right-2 text-white bg-black bg-opacity-50 hover:bg-opacity-75 rounded-full w-10 h-10 flex items-center justify-center transition-all" (click)="closeImageModal()">
			<i class="fa fa-times text-xl"></i>
		</button>
		<img [src]="fullImageSrc" alt="Image en taille réelle" class="max-w-full max-h-screen object-contain rounded-lg" (click)="$event.stopPropagation()" />
	</div>
</div>
